import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';
import { CoreResponseUtilsService } from '@core/services/utils/response-utils.service';

import * as Objects from '@core/objects';
import { VersionShareItem } from '@core/models/version-share.model';
import { VersionSharesService } from '@core/services/version-shares/version-shares.service';


@Injectable({
    providedIn: 'root'
})
export class ProjectRelatedVersionsRequests {

    private readonly prefix = "/projects";

    constructor(private http: HttpClient, private urlSrv: UrlService,
        private responseUtilsSrv: CoreResponseUtilsService, // for testing purposes
        private versionSharesSrv: VersionSharesService
    ) { }


    public loadRelated$ = (id: number) =>
        this.http.get<Objects.Version[]>(this.urlSrv.build(this.prefix + "/" + id + "/versions/related"));

    
    // oct-2026: replaces the legacy bubbles call. One version uses GET /versions/{vid}/shares, several GET /versions/shares?versions=...
    public getRelatedShareItems$ = (versions: Objects.Version[]): Observable<VersionShareItem[]> =>
        this.versionSharesSrv.getVersionShareItems$(versions);

    // @deprecated oct-2026: legacy share feedback bubbles url call (GET /p/feedback/versions/feedbacks/{ids}), removed in the backend (answers 404)
    // public getRelatedFeedbacks$ = (versions: Objects.Version[]): Observable<VersionFeedback[]> => {
    //     return this.http.get<VersionFeedback[]>(
    //         this.urlSrv.build("/p/feedback/versions/feedbacks/" + versions.map((v: Objects.Version) => v.id).join('-')));
    // }


}
